<template>
  <v-container fluid>
    <v-container>
      <v-row>
        <v-col>
          <h1>Operazioni</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <stats :stats="stats" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <tabella-operazioni
            v-on:open-bottom-sheet="isBottomSheetOpen = true"
            v-on:fetch="fetchDailyOperations"
            :operations="ops"
          />
        </v-col>
      </v-row>
      <v-bottom-sheet v-model="isBottomSheetOpen">
        <new-operation-form v-on:update-operations="fetchDailyOperations" />
      </v-bottom-sheet>
    </v-container>
  </v-container>
</template>

<script>
  import axios from 'axios'

  import TabellaOperazioni from './../components/registro/TabellaOperazioni'
  import NewOperationForm from './../components/registro/NewOperationForm'
  import Stats from './../components/registro/Stats'

  export default {
    name: 'RegistroGenerale',
    components: {
      TabellaOperazioni,
      NewOperationForm,
      Stats,
    },
    data() {
      return {
        operations: [],
        isBottomSheetOpen: false,
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },
    computed: {
      ops() {
        return this.operations
      },
      stats() {
        if (this.operations.length > 0) {
          const scontrinato = this.operations
            .map((el) => (!el.invoice ? el.price : 0))
            .reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
            .toFixed(2)
          const fatturato = this.operations
            .map((el) => (el.invoice ? el.price : 0))
            .reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
            .toFixed(2)
          const utile = this.operations
            .map((el) => el.gain)
            .reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
            .toFixed(2)
          const iva = this.operations
            .map((el) => el.vat)
            .reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
            .toFixed(2)
          const margine = ((utile * 100) / (parseFloat(scontrinato) + parseFloat(fatturato))).toFixed(2)
          const omaggi = this.operations
            .map((el) => el.gift)
            .reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
          const fatture = this.operations
            .map((el) => el.invoice)
            .reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
          const caffe = this.operations
            .map((el) => el.coffee)
            .reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))

          return [
            {
              title: 'Scontrinato',
              count: scontrinato + '€',
            },
            {
              title: 'Fatturato',
              count: fatturato + '€',
            },
            {
              title: 'Utile',
              count: utile + '€',
            },
            {
              title: 'Margine',
              count: margine + '%',
            },
            {
              title: 'Iva',
              count: iva + '€',
            },
            {
              title: 'Omaggi',
              count: omaggi,
            },
            {
              title: 'Fatture',
              count: fatture,
            },
            {
              title: 'Caffè',
              count: caffe,
            },
          ]
        }
      },
    },
    methods: {
      async fetchDailyOperations() {
        try {
          let { data } = await axios.get(`${process.env.VUE_APP_API}/operations/fetch-daily`, this.config)

          this.operations = data
        } catch (error) {
          console.log(error)

          this.operations = []
        }
      },
    },
    async created() {
      await this.fetchDailyOperations()
    },
  }
</script>

<style></style>
